import { InternalIssueTypeEnum } from '../../enums/internalIssueTypeEnum';
import { ReportMetadataBM } from '../../types/BusinessModel/Verification/ReportMetadataBM';
import { ReportMetadata } from '../../types/ViewModel/Verification/ReportMetadata';
import { createInternalIssuesList } from './InternalVerificationIssueFactory';
import { createVerificationResponseList } from './VerificationFactory';

export const createReportMetadata = (reportMetadata: ReportMetadataBM): ReportMetadata => {
    return {
        reportId: reportMetadata.reportId,
        imoNumber: reportMetadata.imoNumber,
        reportType: reportMetadata.reportType,
        voyageNumber: reportMetadata.voyageNumber,
        voyageDateTimeUtcFrom: reportMetadata.voyageDateTimeUtcFrom,
        voyageDateTimeUtcTo: reportMetadata.voyageDateTimeUtcTo,
        portFrom: reportMetadata.portFrom,
        portFromUnCode: reportMetadata.portFromUnCode,
        portTo: reportMetadata.portTo,
        portToUnCode: reportMetadata.portToUnCode,
        status: reportMetadata.status,
        latestReportTimestamp: reportMetadata.latestReportTimestamp,
        generatedReportTimestamp: reportMetadata.generatedReportTimestamp,
        sentToDNVAtTimestamp: reportMetadata.sentToDNVAtTimestamp,
        reportTimestampSentToDNV: reportMetadata.reportTimestampSentToDNV,
        lastSentByUser: reportMetadata.lastSentByUser,
        latestReportVersion: reportMetadata.latestReportVersion,
        reportVersionSentToDNV: reportMetadata.reportVersionSentToDNV,
        latestReportFileName: reportMetadata.latestReportFileName,
        reportSentToDNVFileName: reportMetadata.reportSentToDNVFileName,
        internalVerificationIssues: createInternalIssuesList(reportMetadata.internalVerificationIssues),
        missingAolIssues: createInternalIssuesList(
            reportMetadata.internalVerificationIssues?.filter((r) => r.typeId === InternalIssueTypeEnum.MissingAol)
        ),
        missingPositionsIssues: createInternalIssuesList(
            reportMetadata.internalVerificationIssues?.filter((r) => r.typeId === InternalIssueTypeEnum.MissingPosition)
        ),
        timeInconsistencyIssues: createInternalIssuesList(
            reportMetadata.internalVerificationIssues?.filter((r) => r.typeId === InternalIssueTypeEnum.TimeInconsistency)
        ),
        reportFormatIssues: createInternalIssuesList(
            reportMetadata.internalVerificationIssues?.filter((r) => r.typeId === InternalIssueTypeEnum.ReportFormatError)
        ),
        dnvIssues: reportMetadata.dnvIssues != null ? createVerificationResponseList(reportMetadata.dnvIssues) : null,
        verificationList: reportMetadata.dnvIssues != null ? createVerificationResponseList(reportMetadata.dnvIssues) : null,
        bunkeringNumber: reportMetadata.bunkeringNumber,
        comment: reportMetadata.comment,
        acceptedByUser: reportMetadata.acceptedByUser,
        acceptedAt: reportMetadata.acceptedAt,
    };
};

export const createReportMetadataList = (reportMetadataList: ReportMetadataBM[]) =>
    reportMetadataList?.map((reportMetadata) => createReportMetadata(reportMetadata));
